module.exports = __webpack_public_path__ + "static/media/Project-Medical.807354a3.svg";